import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import { getBackgroundTheme } from '../../../style';
import { commonIcons } from '../../../atoms/icons/materialIcons';
import BackPackageIcon from '../../../atoms/icons/BackPackageIcon';
import breakpoints from '../../../theme/material/breakpoints';
import { FONT_FAMILIES } from 'theme/material/constants';

const HeaderContainer = styled('div')({
  display: 'flex',
  position: 'relative',
  padding: '30px 0',
  [breakpoints.down(769.05)]: {
    padding: '20px 0 14px 0',
  },
});

const LeftContent = styled('div')({
  position: 'fixed',
  top: 55,
  left: 10,
  width: 'auto',
  height: 'auto',
  zIndex: 996,
});

const RightContent = styled('div')({
  alignItems: 'flex-end',
  textAlign: 'center',
  flex: 10,
});

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const TopTitle = styled('div')(() => ({
  color: getBackgroundTheme().billingHeading,
  fontFamily: FONT_FAMILIES.secondary,
  fontSize: 28,
  fontWeight: 400,
  lineHeight: '40px',
  letterSpacing: -0.28,
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& > svg': {
    marginLeft: '0 !important',
  },
}));

interface BillingHeaderProps {
  label: string;
  onBackClick?: any;
  isSuccess?: boolean;
  newBilling?: boolean;
}

const BillingHeader = ({ label = '', onBackClick, isSuccess = false }: BillingHeaderProps): ReactElement => {
  return (
    <HeaderContainer>
      {onBackClick && (
        <LeftContent>
          <BackPackageIcon onClick={onBackClick} data-test-id="billing-header-back" />
        </LeftContent>
      )}
      <RightContent>
        <TopTitle data-test-id="billing-header-label">
          {isSuccess && <commonIcons.check.default />} <span>{label}</span>
        </TopTitle>
      </RightContent>
    </HeaderContainer>
  );
};

export default BillingHeader;
